import { postJson } from '../../util/fetch-json.js';
import type { BrandBrief, Customizations } from '../../types/manifest.js';
import type { NewsStory, TextProvider } from '../provider.js';

export const serverText: TextProvider = {
  fetchTopUSStory: () => postJson<NewsStory>('/api/news', { scope: 'us' }),
  fetchTopLocalStory: (city) => postJson<NewsStory>('/api/news', { scope: 'local', city }),
  fetchBrandBrief: async (prospect, companyPrompt) => {
    const r = await postJson<{ brief: BrandBrief }>('/api/brand-brief', { key: prospect, companyPrompt });
    return r.brief;
  },
  craftNewsVideoPrompt: async (scope, story) => {
    const r = await postJson<{ prompt: string }>('/api/news-video-prompt', { scope, story });
    return r.prompt;
  },
  saveCustomizations: async (prospect, customizations) => {
    await postJson<{ manifest: unknown }>('/api/customize', { key: prospect, customizations });
  },
  runGemini: async (prompt, opts) => {
    const r = await postJson<{ result: string }>('/api/run-gemini-text', { prompt, ...(opts?.useSearch ? { useSearch: true } : {}) });
    return r.result;
  },
};
